import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgUploadIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#03A9F4",
		fillRule: "nonzero",
		d: "M64 30.476H33.524V0h-3.048v30.476H0v3.048h30.476V64h3.048V33.524H64z"
	})
});
export default SvgUploadIcon;
